<script setup>
const sustainabilityStore = useSustainabilityStore();
const useRoute = useRouteStore();
const { locale } = useI18n();
const { useUrl } = useUrls();
const toastStore = useToastStore();
const { isLargeScreen } = useMq();
const runtimeConfig = useRuntimeConfig();

const COOKIESPOLICYURL = useUrl.getCookiePolicyUrl();
const SECURITYPRIVACYURL = useUrl.getSecurityPrivacyUrl();

const actualLanguage = locale?.value;

// @TODO: For some weird reason, the trustArc banner is being rendered twice on DOM, but script is only called once
const trustArcScript = [
  {
    key: 'trustarc',
    async: true,
    crossorigin: 'anonymous',
    fetchpriority: 'high',
    src:
      'https://consent.trustarc.com/notice?domain=hostelworld.com'
      + '&c=teconsent'
      + '&gtm=1'
      + '&js=nj'
      + '&noticeType=bb'
      + `&language=${actualLanguage}`
      + '&language=true'
      + '&text=true'
      + `&cookieLink=${encodeURIComponent(`${COOKIESPOLICYURL}`)}&privacypolicylink=${encodeURIComponent(
        `${SECURITYPRIVACYURL}`,
      )}`,
  },
];

// Load PCI Proxy script for credit card tokenization
useHead({
  script: [
    {
      src: runtimeConfig.public.PCI_PROXY_DOMAIN,
      async: true,
      defer: true,
    },
    ...trustArcScript,
  ],
});

onBeforeMount(() => {
  if (process.client) {
    document.body.style.overflow = '';
  }
});
</script>

<template>
  <div class="account-content-wrapper">
    <ClientOnly>
      <CommonHwNavBar
        v-if="isLargeScreen"
        account-mode
      />
    </ClientOnly>

    <slot />

    <CommonHwFooter />

    <ClientOnly>
      <LazyCommonHwLanguagePicker />
      <LazyCommonHwCurrencyPicker />
      <LazyCommonHwSustainabilityPopup v-if="sustainabilityStore.isSustainabilityPopupOpen" />
      <LazyCommonHwSocialPermissionsPopup v-if="useRoute.getPageKey !== 'generic'" />
      <LazyCommonHwCookieBar />
      <CommonHwToast
        v-if="toastStore.toast"
        v-bind="toastStore.toast"
        @dismiss="toastStore.hide()"
      />
    </ClientOnly>
  </div>
</template>

<style lang="scss">
.page-inner {
  max-width: 100%;
  padding: 0 $wds-spacing-s;
  margin: auto;

  @include tablet {
    margin: 0 auto;
    padding: 0 $wds-spacing-m;
    max-width: calc(100% - #{$wds-spacing-xl});
    width: 70rem;
  }
}

.account-content-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  .footer-wds {
    margin-top: auto;
  }
}
</style>
